import { ENDPOINTS } from "../config";
import { generateRequest, orchestrateBenchmarkResponse } from "../utils";
import { IDataEntityResponse, ISearchEntityRequest } from "../models";

export const BASE_BMRK_REQUEST: ISearchEntityRequest = {
	type: "BMRK",
	search: [],
	include: {
		statistics: {},
		timeseries: {}
	},
	start: 0,
	limit: 200
};


export async function fetchBenchmarks(): Promise<IDataEntityResponse> {
	let response: IDataEntityResponse;
	let request = await fetch(ENDPOINTS.fund.searchEntity, generateRequest("POST", BASE_BMRK_REQUEST));
	if (request.ok) {
		response = await request.json();
	} else {
		response.error = new Error(request.statusText);
	}
	response = orchestrateBenchmarkResponse(response)
	return response;
}




// WEBPACK FOOTER //
// ./src/client/data/benchmarks.ts